import clsx from 'clsx'
import {PropsWithChildren, useEffect, useState} from 'react'
import {createPortal} from 'react-dom'
import {CloseIcon} from './components/CloseIcon'

export interface ModalStateProps {
  isOpen: boolean
  onClose: () => void
  bgColor?: string
  overlayColor?: string
}

interface ModalProps extends PropsWithChildren, ModalStateProps {
  onRenderedChange?: () => void
  id?: string
}

export const Modal = ({
  children,
  isOpen,
  onClose,
  onRenderedChange,
  id,
  overlayColor = 'rgba(7,17,68,0.64)',
  bgColor = '#071144',
}: ModalProps) => {
  const [isRendered, setIsRendered] = useState(isOpen)

  useEffect(() => {
    if (isOpen) {
      setIsRendered(true)
    } else {
      setTimeout(() => setIsRendered(false), 700)
    }
  }, [isOpen])

  useEffect(() => {
    if (onRenderedChange) onRenderedChange()
  }, [isRendered, onRenderedChange])

  if (!isRendered && !isOpen) return null

  return createPortal(
    <div
      id={id}
      onClick={() => onClose()}
      className={clsx(
        'pointer-events-auto',
        'h-hull fixed inset-0 z-[1000] flex w-full items-center justify-center',
        'transition-opacity duration-300',
        isOpen ? 'opacity-1' : 'opacity-0',
      )}
      style={{
        backgroundColor: !!overlayColor ? overlayColor : 'rgba(7,17,68,0.64)',
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        className={clsx(
          'relative box-border rounded-[16px] border-[1px] p-6',
          'border-[rgba(255,255,255,0.28)] shadow-[0_0_64px_0_rgba(255,255,255,0.4)]',
          'm-auto max-h-[90%] w-[380px] max-w-[90%]',
          'overflow-auto transition-transform duration-300',
          isOpen ? 'scale-1' : 'scale-0',
        )}
        style={{backgroundColor: bgColor}}
      >
        <div
          id="close-modal"
          onClick={() => onClose()}
          className="absolute top-4 right-4 cursor-pointer p-1 transition-transform duration-300 hover:scale-[1.4]"
        >
          <CloseIcon color="white" />
        </div>
        {children}
      </div>
    </div>,
    document.body,
  )
}
